import { debug } from 'console';
import { ConveniosTreeViewService } from '../services/convenios-tree-view.service';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { AddConveniosComponent } from './add-convenios/add-convenios.component';
import { Subscription } from 'rxjs';
import { SharedService } from 'app/modules/common/services/shared-service';

/**
 * Food data with nested structure.
 * Each node has a name and an optional list of children.
 */
interface ConveniosNode {
  nombre: string;
  convenioId: number;
  grupo: string;
  children?: ConveniosNode[];

}
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}
@Component({
    selector: 'app-convenios-list',
    templateUrl: './convenios-list.component.html',
    styleUrls: ['./convenios-list.component.scss'],
    standalone: false
})

export class ConveniosListComponent implements OnInit {
  @Output() notifySelectedNode = new EventEmitter<[]>();
  IsEdit: boolean;
  clickEventSubscription: Subscription;
  treeData;
  activeNode;

  private _transformer = (node: ConveniosNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.grupo,
      nombre: node.nombre,
      convenioId: node.convenioId,
      level: level,
    };
  };

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
    this._transformer, node => node.level, node => node.expandable, node => node.children);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor(
    private _conveniosTreeViewService: ConveniosTreeViewService,
    private dialog: MatDialog,
    private _sharedService: SharedService,
  ) {

    this.clickEventSubscription = this._conveniosTreeViewService.getClickUpdateEvent().subscribe(() => {
      this._conveniosTreeViewService.convenioEditedValue.subscribe(companyId => this.IsEdit = companyId);
      this.loadTreeView();
    });
    this.loadTreeView();
  }

  notifyNode(node: []): void {
    this.notifySelectedNode.emit(node);
    this._conveniosTreeViewService.changeTopButtonEditStatus(true);
    this._conveniosTreeViewService.sendClickUpdateTopButtonsEvent();
  }

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    this.loadTreeView();
  }

  public loadTreeView() {
    this._conveniosTreeViewService.getConveniosTreeView().subscribe(res => {
      if (res) {
        this.treeData = res;
        this.dataSource.data = this.treeData;
      }
    });
  }

  public addnewconvenios(data: any): void {
    const modalRef = this.dialog.open(AddConveniosComponent, {
      data: { isInsert: true }
    });
    modalRef.afterClosed().subscribe(res => {
      if (res) {
        this._sharedService.ShowSnackBar('Guardado exitosamente', 'Okay', 2000);
        this._conveniosTreeViewService.changeTopButtonEditStatus(false);
        this._conveniosTreeViewService.sendClickUpdateTopButtonsEvent();

        this.loadTreeView();
        this.notifySelectedNode.emit(null);
      }
    });
  }

}
